import Vue from "vue";
import Vuex from "vuex";
import kLineStock from './modules/kLineStock'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userUrl: "",
  },
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    kLineStock
  },
});
